import script from "./SimilarPatents.vue?vue&type=script&setup=true&lang=js"
export * from "./SimilarPatents.vue?vue&type=script&setup=true&lang=js"

import "./SimilarPatents.vue?vue&type=style&index=0&id=ace32a96&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ace32a96"]])

export default __exports__